import React from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Image from '@tiptap/extension-image';
import { YouTube } from '../admin/base/controls/YouTubeExtension';

interface TipTapViewerProps {
  content: any; // TipTap JSON or HTML string
  className?: string;
}

const TipTapViewer: React.FC<TipTapViewerProps> = ({ content, className }) => {
  const editor = useEditor({
    editable: false,
    extensions: [StarterKit, Underline, Image, YouTube],
    content: content || { type: 'doc', content: [] },
  });

  // Update content when it changes
  React.useEffect(() => {
    if (editor && content) {
      const current = editor.getJSON();
      const incoming = typeof content === 'string' ? content : JSON.stringify(content);
      const currentStr = JSON.stringify(current);
      if (currentStr !== incoming) {
        editor.commands.setContent(content, false);
      }
    }
  }, [editor, content]);

  React.useEffect(() => {
    return () => {
      editor?.destroy();
    };
  }, [editor]);

  return (
    <div className={`tiptap-editor tiptap-viewer ${className ?? ''}`}>
      <EditorContent editor={editor} />
    </div>
  );
};

export default TipTapViewer;
